<script setup>
import {computed} from "vue";
import useDates from "@/composables/useDates";
import {kitName} from "@/composables/useLocalDomains";

const {formattedDate} = useDates();

const props = defineProps({
  user: {
    type: [Object, null],
    required: false,
    default: null,
  },
  date: {
    type: String,
    required: true,
  },
});

const initials = computed(() => {
  if (!props.user?.name) {
    return '';
  }

  return props.user.name.split(' ')
    .map(word => word[0])
    .slice(0,2)
    .join('')
    .toUpperCase();
})

const tooltip = computed(() => {
  const name = props.user?.name ?? kitName.value;
  const time = formattedDate(props.date, 'HH:mm');
  const date = formattedDate(props.date);
  return `Approved by <strong>${name}</strong><br>at ${time} on ${date}`
});

</script>

<template>
  <div
    v-tooltip="{
      content: tooltip,
      html: true,
      placement: 'bottom',
      theme: 'dark-blue-tooltip'
    }"
    class="tw-max-w-full tw-flex tw-items-center tw-border tw-gap-2 tw-rounded-full tw-p-1.5 tw-pr-6 tw-w-fit"
    :class="[
      user?.name ? 'tw-border-primary tw-bg-primary-100' : 'tw-border-info tw-bg-info-100'
    ]"
  >
    <div
      class="tw-flex-shrink-0 tw-text-xs tw-font-bold tw-flex tw-justify-center tw-items-center tw-border tw-bg-white tw-rounded-full tw-h-9 tw-w-9"
      :class="[
        user?.name ? 'tw-border-primary tw-text-primary ' : 'tw-text-info  tw-border-info'
      ]"
    >
      <svg-vue
        v-if="!user?.name"
        icon="icons/user-outline"
        class="tw-h-4 tw-w-4"
      />
      <div v-else>
        {{ initials }}
      </div>
    </div>

    <span
      class="tw-font-bold tw-truncate"
      :class="[
        user?.name ? 'tw-text-neutral-900' : 'tw-text-info'
      ]"
    >
      {{ user?.name ? 'You' : kitName }}
    </span>
  </div>
</template>
